import { PaymentResult } from '@core/models';
import {
	CheckoutPaymentInput,
	CheckoutPaymentPlan,
	CheckoutPaymentStrategy,
} from '../interfaces/checkout-payment.interface';
import { CheckoutOrderValidationError } from '../enum/checkout-order-validation.enum';
import { CheckoutPaymentPlanType } from '../enum/checkout-flow.enum';

export class CardPaymentStrategy implements CheckoutPaymentStrategy {
	prepare(input: CheckoutPaymentInput): CheckoutPaymentPlan {
		const vaultedCardToken =
			input.selectedCardToken || input.defaultCardToken || input.associatedCardToken;
		const workDayId = input.order.workDay?.idlaboral;

		if (!vaultedCardToken || !workDayId || !input.order.storeData?.idLocal) {
			return {
				type: CheckoutPaymentPlanType.Invalid,
				order: input.order,
				error: CheckoutOrderValidationError.PaymentDataIncomplete,
			};
		}

		return {
			type: CheckoutPaymentPlanType.Card,
			order: input.order,
			request: {
				amount: input.amount,
				localId: input.order.storeData.idLocal,
				diaLaboralId: workDayId,
				isGuest: !input.isLoggedIn,
				vaultedCardToken,
			},
		};
	}

	acceptsResult(result: PaymentResult): boolean {
		return result.success;
	}
}
